function escapeHtml(str) {
	return str.replace(/[&"'<>`]/g, (str) => {
		const special = {
			'<': '&lt;',
			'>': '&gt;',
			'&': '&amp;',
			"'": '&#39;',
			'`': '&#96;',
		};

		if (typeof special[str] === 'string') {
			return special[str];
		}

		return '&quot;';
	});
}

export default escapeHtml;
